import styled from 'styled-components';
import { colors } from '@keen.io/colors';

const SettingsDivider = styled.div`
  margin: 15px 0;
  height: 1px;
  background: ${colors.white[300]};
`;

export default SettingsDivider;
